import { render, staticRenderFns } from "./detailInformationAutoClaim.vue?vue&type=template&id=ad27ac64&"
import script from "./detailInformationAutoClaim.vue?vue&type=script&lang=js&"
export * from "./detailInformationAutoClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports